export class DialogModelGeneratePO {
    constructor(
    ) {}
  }
  